import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import NFFilter from '../components/FilterContainer';
import FilterForm from '../components/FilterForm';
import CheckboxControl from '../components/CheckboxControl';
import { INVOICE, invoiceEnumTransKey } from '../enums';

import { Container } from '../styles';

const label = Object.values(INVOICE);

const Invoice = ({ isOpen, onClick, onApply, nfType }) => {
  const [selectedItem, setSelectedItem] = useState(nfType);

  useEffect(() => {
    if(nfType?.length < 1) {
      setSelectedItem([]);
    }
  }, [nfType]);

  const handleChange = e => {
    if (!e.target.checked) {
      setSelectedItem(
        selectedItem.filter(item => Number(item) !== Number(e.target.value)),
      );
    } else if (e.target.checked) {
      setSelectedItem([...selectedItem, e.target.value]);
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    onApply(selectedItem);
  };

  const clearFilter = () => {
    setSelectedItem([]);
    onApply([]);
  };

  return (
    <NFFilter label="Tipo de nota" isOpen={isOpen} onClick={onClick}>
      <FilterForm
        label="Filtrar por tipo de nota"
        onSubmit={handleSubmit}
        clearFilter={clearFilter}
      >
        <Container>
          {label.map((filter, idx) => (
            <CheckboxControl
              key={Number(idx)}
              value={filter}
              onChange={handleChange}
              defaultChecked={selectedItem.some(
                item => parseInt(item) === filter,
              )}
              label={invoiceEnumTransKey[filter]}
            />
          ))}
        </Container>
      </FilterForm>
    </NFFilter>
  );
};

const mapStateToProps = state => ({
  nfType: state.tracking.filters.nfType,
});

export default connect(mapStateToProps)(Invoice);
